import { observer } from 'mobx-react-lite'
import { Alert, Box } from 'shared/ui'
import { useUrlShortenerContext } from 'pages/settings/pages/urlShortener/context/UrlShortenerContext'

export const UrlShortenerInfo = observer(() => {
  const { isStatusVerificationFailed, isStatusPendingPayment } = useUrlShortenerContext()

  if (!isStatusVerificationFailed && !isStatusPendingPayment) return null

  const infoText = isStatusVerificationFailed
    ? 'Verification failed. Review your DNS setup and try again.'
    : 'Finalize the payment to start using your custom URL shortener.'

  return (
    <Box marginTop={'-11px'} marginBottom={'32px'}>
      <Alert
        item={{
          type: 'infoBlue',
          desc: infoText,
        }}
      />
    </Box>
  )
})
